// Product data for Agatsya International

export const agroProducts = [
  {
    id: 1,
    name: 'Dry Turmeric',
    category: 'agro',
    description: 'Premium quality whole turmeric, naturally dried and sourced from the finest farms.',
    image: '/dry-turmeric.png',
    featured: true,
  },
  {
    id: 2,
    name: 'Dry Red Chilli',
    category: 'agro',
    description: 'Vibrant, aromatic red chillies with consistent heat and rich color.',
    image: '/dry-red-chilli.png',
    featured: false,
  },
  {
    id: 3,
    name: 'Turmeric Powder',
    category: 'agro',
    description: 'Finely ground turmeric powder with high curcumin content and golden color.',
    image: '/turmeric-powder.png',
    featured: false,
  },
  {
    id: 4,
    name: 'Red Chilli Powder',
    category: 'agro',
    description: 'Pure chilli powder with intense flavor and color, perfect for export markets.',
    image: '/red-chilli-powder.png',
    featured: false,
  },
  {
    id: 5,
    name: 'Jaggery Powder',
    category: 'agro',
    description: 'Natural, unrefined sweetener with rich nutritional value and authentic taste.',
    image: '/jaggery-powder.png',
    featured: false,
  },
];

export const chemicalProducts = {
  industrial: [
    {
      id: 'chem-1',
      name: 'Tata Soda Ash',
      category: 'chemical',
      subcategory: 'industrial',
      grade: 'Technical Grade',
      description: 'High-purity sodium carbonate for industrial applications including glass manufacturing, detergents, and chemical processing.',
      specifications: ['Purity: 99%+', 'Technical Grade', 'Bulk & Wholesale Available'],
      applications: ['Glass Manufacturing', 'Detergent Production', 'Water Treatment', 'Chemical Processing'],
    },
    {
      id: 'chem-2',
      name: 'Dye Fixing Agent',
      category: 'chemical',
      subcategory: 'industrial',
      grade: 'Textile Grade',
      description: 'Premium quality dye fixing agent for textile industries ensuring excellent color fastness and durability.',
      specifications: ['Textile Grade', 'High Fastness', 'Eco-friendly Formula'],
      applications: ['Textile Dyeing', 'Color Fixation', 'Fabric Treatment', 'Industrial Laundry'],
    },
  ],
  cleaning: [
    {
      id: 'clean-1',
      name: 'Dishwash Liquid',
      category: 'chemical',
      subcategory: 'cleaning',
      brand: 'Agatsya',
      icon: 'bottle',
      description: 'Powerful grease-cutting formula with lemon fresh fragrance. Gentle on hands, tough on stains.',
      features: ['Grease Cutting', 'Lemon Fresh', 'Gentle Formula', 'Biodegradable'],
      sizes: ['500ml', '1L', '5L', '50L Bulk'],
    },
    {
      id: 'clean-2',
      name: 'Detergent',
      category: 'chemical',
      subcategory: 'cleaning',
      brand: 'Agatsya',
      icon: 'bottle',
      description: 'High-efficiency liquid detergent for all fabric types. Works in both hot and cold water.',
      features: ['Deep Cleaning', 'Fabric Care', 'Fresh Fragrance', 'Color Safe'],
      sizes: ['1L', '5L', '50L Bulk'],
    },
    {
      id: 'clean-3',
      name: 'Floor Cleaner',
      category: 'chemical',
      subcategory: 'cleaning',
      brand: 'Agatsya',
      icon: 'bottle',
      description: 'Multi-surface floor cleaner with antibacterial properties. Leaves floors sparkling clean.',
      features: ['Antibacterial', 'Multi-Surface', 'Pleasant Fragrance', 'Streak-Free'],
      sizes: ['500ml', '1L', '5L', '50L Bulk'],
    },
    {
      id: 'clean-4',
      name: 'Room Freshener',
      category: 'chemical',
      subcategory: 'cleaning',
      brand: 'Agatsya',
      icon: 'spray',
      description: 'Long-lasting room freshener spray with natural fragrance oils. Eliminates odors instantly.',
      features: ['Long Lasting', 'Natural Oils', 'Multiple Fragrances', 'Instant Action'],
      sizes: ['1L', '5L', 'Bulk'],
    },
    {
      id: 'clean-5',
      name: 'Toilet Cleaner',
      category: 'chemical',
      subcategory: 'cleaning',
      brand: 'Agatsya',
      icon: 'bottle',
      description: 'Powerful toilet bowl cleaner with thick formula for better cleaning and disinfection.',
      features: ['Thick Formula', '10X Power', 'Germ Kill'],
      sizes: ['500ml', '1L', '5L', '50L Bulk'],
    },
    {
      id: 'clean-6',
      name: 'Handwash',
      category: 'chemical',
      subcategory: 'cleaning',
      brand: 'Agatsya',
      icon: 'bottle',
      description: 'Gentle antibacterial handwash with moisturizing formula. Keeps hands soft and germ-free.',
      features: ['Antibacterial', 'Moisturizing', 'pH Balanced', 'Dermatologically Tested'],
      sizes: ['500ml', '1L', '5L', '50L Bulk'],
    },
  ],
};

export const whatsappNumber = '+919226059195';

export const getWhatsAppLink = (productName) => {
  const message = encodeURIComponent(
    `Hi, I'm interested in wholesale inquiry for ${productName}. Please provide more details.`
  );
  return `https://wa.me/${whatsappNumber.replace('+', '')}?text=${message}`;
};
